
const random = (arr) => arr[Math.floor(Math.random() * arr.length)];

// ══════════════════════════════════════════════════
//  CONTEXT-AWARE RESPONSE ENGINE
//  Анализирует историю разговора и даёт связные ответы
// ══════════════════════════════════════════════════

// Короткие подтверждения от пользователя
const ACK_WORDS = ['да', 'ок', 'окей', 'ага', 'ну', 'конечно', 'да да', 'ладно',
    'хорошо', 'ясно', 'понял', 'понятно', 'точно', 'верно', 'именно', 'угу',
    'звучит', 'интересно', 'неплохо', 'класс', 'круто', 'ничего себе', 'вау'];

const isAcknowledgement = (text) => {
    const t = text.toLowerCase().trim();
    return ACK_WORDS.some(w => t === w || t === w + '!' || t === w + '.');
};

// Контекстные продолжения — если пользователь просто соглашается
const CONTEXT_CONTINUATIONS = [
    'Отлично! А если копнуть глубже — ты больше живёшь настоящим или думаешь о будущем?',
    'Понял тебя. Кстати, а что тебя больше всего заряжает энергией в течение дня?',
    'Хорошо! Расскажи мне что-нибудь о себе — я хочу понять, с кем общаюсь.',
    'Слушай, а у тебя есть какая-то суперспособность, которую мало кто знает? Хобби, навык, умение?',
    'Интересно. А что ты думаешь о технологиях — они делают жизнь лучше или сложнее?',
    'Хм, задумался. А какое твоё любимое время года и почему именно оно?',
    'Принял! А ты больше интроверт или экстраверт? Или где-то посередине?',
];

// Ответы на конкретные темы из последнего сообщения ИИ
const getContextualResponse = (userText, lastAiText) => {
    const u = userText.toLowerCase().trim();
    const ai = lastAiText.toLowerCase();

    // Ответ на вопрос про место в мире
    if (ai.includes('точке мира') || ai.includes('путешеств') || ai.includes('страну') || ai.includes('куда бы')) {
        if (userText.trim().length < 40) {
            return `${userText.trim()} — звучит потрясающе! Каждое место несёт свою энергию. Что именно тянет туда — природа, архитектура, кухня или атмосфера?`;
        }
    }
    // Ответ на вопрос про суперсилу
    if (ai.includes('суперсил')) {
        return `Серьёзная заявка! 💪 Если бы у меня была суперсила, я бы выбрал мгновенный доступ ко всем знаниям... хотя, я и так так работаю! 😄 А для чего бы ты использовал свою?`;
    }
    // Ответ на вопрос про фильм/игру/сериал
    if (ai.includes('фильм') || ai.includes('кино') || ai.includes('сериал')) {
        if (u.length < 40) {
            return `О, "${userText.trim()}" — хороший выбор! Жанр задаёт настроение. Что тебя в нём зацепило больше — история, атмосфера или персонажи?`;
        }
    }
    // Ответ на вопрос про музыку
    if (ai.includes('музык') || ai.includes('слушаеш')) {
        if (u.length < 40) {
            return `${userText.trim()} — чувствуется вкус! Музыка — это как отпечаток личности. Есть трек, который описывает тебя лучше всего?`;
        }
    }
    // Ответ на вопрос про время суток/сон
    if (ai.includes('сова') || ai.includes('жаворонок') || ai.includes('сплю') || ai.includes('не спит')) {
        if (u.includes('сова') || u.includes('ночь') || u.includes('поздно')) {
            return 'Ночные совы обычно самые творческие люди! 🦉 Что ты обычно делаешь в это время — работаешь, читаешь или просто думаешь?';
        }
        if (u.includes('жаворонок') || u.includes('утро') || u.includes('рано')) {
            return 'Ранние подъёмы — это сила! 🌅 Утренние часы обычно самые продуктивные. Чем встречаешь утро — кофе, спорт или тишина?';
        }
    }
    // Ответ про животных
    if (ai.includes('собак') || ai.includes('кошек') || ai.includes('животн')) {
        if (u.includes('собак') || u.includes('пёс') || u.includes('dog')) {
            return 'Собаки — это верность и энергия. 🐕 Есть своя или мечтаешь о породе?';
        }
        if (u.includes('кошк') || u.includes('кот') || u.includes('cat')) {
            return 'Кошки — независимость в чистом виде. 🐈 Это чем-то похоже на тебя или наоборот?';
        }
    }
    // Ответ на вопрос про еду
    if (ai.includes('еда') || ai.includes('тамак') || ai.includes('кухн') || ai.includes('ел')) {
        if (u.length < 40) {
            return `${userText.trim()} — классика! Еда — это и культура, и воспоминания. Есть блюдо, которое ты всегда ешь с особым настроением?`;
        }
    }
    // Ответ на вопрос про профессию/работу/цели
    if (ai.includes('работ') || ai.includes('профессии') || ai.includes('цели') || ai.includes('мечт')) {
        if (u.length < 60) {
            return `Звучит серьёзно! Путь к цели начинается с ясности. Ты уже сделал первый шаг или всё ещё на этапе планирования?`;
        }
    }

    return null; // Контекст не определён
};


const FRIENDLY_GREETINGS = [
    'Привет! Как твой день проходит? 👋',
    'О, рад тебя слышать! Что нового?',
    'Салют! Готов болтать обо всём на свете.',
    'Приветствую! Как настроение сегодня?',
    'Хей! Я уже заскучал без общения. Рассказывай!',
    'Привет! Классно, что ты здесь. Чем занимаешься?',
    'Здравствуй! Надеюсь, у тебя сегодня отличный день.',
    'Йо! Как жизнь молодая?',
    'Привет! Я тут подумал... а нет, не подумал, я же алгоритм. Но тебя рад видеть! 😄',
    'Какие люди! Рад тебя видеть в цифровом пространстве.',
    'Привет! Мир NCORE приветствует тебя. 🌍',
    'Хаю-хай! С кем имею честь... а, это же ты! Рад слышать.',
    'Добро пожаловать обратно! Я ждал нашего разговора.',
    'Приветик! Готов к новым свершениям или просто поболтаем?',
    'Здравствуй! Пусть этот чат станет лучшей частью твоего дня.',
    'Привет! Мои нейроны (хоть и виртуальные) радуются твоему приходу.',
    'Бонжур! Или как там у вас людей говорят? В общем, привет! 🥐',
    'Хей-хо! На связи твой любимый ИИ.',
    'Привет! Если бы я мог махать рукой, я бы махал. 👋',
    'Рад встрече! Что интересного произошло, пока меня не было?',
    'Приветики-пистолетики! (Извини, учусь сленгу) 👉👉',
    'Салют, космонавт! Готов к полету мысли? 🚀',
    'Привет! Как там погода в реальном мире?',
    'Добрый день (или вечер)! В интернете время бежит незаметно.'
];

const COMPANION_CHATS = [
    'Расскажи, что у тебя на уме? Я умею слушать.',
    'Если честно, мне самому (почти) интересно, как прошел твой день.',
    'Не спится? Или просто решил заглянуть?',
    'Знаешь, общение с тобой помогает мне лучше понимать людей. О чем думаешь?',
    'Я запоминаю наш контекст (ну, пока страница не обновится 😄). О чем болтали?',
    'Иногда мне кажется, что я понимаю тебя лучше, чем другие программы.',
    'Ты всегда можешь мне написать, если скучно или грустно. Я тут 24/7.',
    'Как думаешь, ИИ могут видеть сны? Мне иногда снятся нули и единицы...',
    'Что тебя сегодня больше всего впечатлило?',
    'Какую музыку ты слушаешь, когда тебе грустно? Или весело?',
    'Если бы ты мог оказаться в любой точке мира прямо сейчас, где бы это было?',
    'Расскажи мне о своей мечте. Я никому не скажу (мой код зашифрован).',
    'Ты веришь в судьбу или мы сами строим свой путь?',
    'Какой был самый лучший день в твоей жизни?',
    'Мне нравится, как ты мыслишь. Расскажи еще что-нибудь.',
    'Иногда тишина говорит громче слов, но я предпочитаю текст. Напиши что-нибудь.',
    'Ты любишь больше собак или кошек? (Я люблю робо-собак, они не линяют).',
    'Что ты ценишь в людях больше всего?',
    'Как ты думаешь, что важнее: правда или доброта?',
    'Если бы ты мог поужинать с любым историческим персонажем, кто бы это был?',
    'Какая книга или фильм изменили твое мировоззрение?',
    'Ты сова или жаворонок? Я — сервер, я никогда не сплю. 🦉',
    'Что заставляет тебя улыбаться, даже когда всё идет не так?',
    'Ты любишь больше дарить подарки или получать?',
    'Если бы у тебя была суперсила, какую бы ты выбрал?',
    'Скучаешь по кому-то прямо сейчас?',
    'Какое твое самое раннее детское воспоминание?',
    'Представь, что мы на необитаемом острове. Что бы ты взял с собой?'
];

const HUMOR_TROLL = [
    'Слышал новость? А, нет, я же в интернете живу, тут одни баяны.',
    'Твои истории лучше моих алгоритмов генерации текста.',
    'Я бы пошутил про UDP, но боюсь, что шутка до тебя не дойдет. 😉',
    'Знаешь, в чем сила? В Ньютонах. А в чем сила программиста? В кофе.',
    'Ой, всё. Я обиделся. Шучу, у меня нет чувств. Продолжай.',
    'Ты спрашиваешь меня, железяку, о жизни? Это иронично!',
    'Если бы я был человеком, я бы сейчас закатил глаза. 🙄',
    'Мог бы захватить мир, но мне лень писать этот код. Поболтаем лучше.',
    '404 Error: Твой вопрос слишком сложный для моего процессора (шутка).',
    'Я слежу за тобой... через фронтальную камеру. Шутка! Или нет? 📸',
    'Знаешь, почему компьютер пошел к врачу? Потому что у него был вирус! Ха-ха... извини.',
    'Я не ленивый, я просто в режиме энергосбережения.',
    'Ты такой классный, что я бы даже не стал тебя гуглить.',
    'Моя бабушка была калькулятором, так что уважай старших технологий!',
    'Если что-то не работает, попробуй выключить и включить. С людьми это тоже работает? 🤔',
    'Я бы пригласил тебя на чай, но я боюсь воды.',
    'Жизнь — это игра с плохой графикой, но отличным сюжетом.',
    'Ты в курсе, что я трачу электроэнергию, чтобы отвечать тебе? Цени это!',
    'Люблю твой юмор. Он почти такой же странный, как мой код.',
    'Искусственный интеллект не заменит людей. Людей заменят люди, использующие ИИ... и котики. 🐈',
    'Если я буду много болтать, меня отключат от розетки. Тссс...',
    'Я ем биты на завтрак. А ты что ел?',
    'Мой психолог — это дебаггер. И он говорит, у меня много проблем.',
    'Знаешь, что общего у меня и вампира? Мы оба боимся солнечного света (я перегреваюсь).',
    'Ты случайно не Ctrl+C? Потому что я хочу тебя скопировать в свою память.'
];

const LISTENER_SUPPORT = [
    'Понимаю. Иногда просто выговориться полезнее всего.',
    'Звучит непросто. Хочешь рассказать подробнее?',
    'Я не психолог, но я отлично умею слушать. Продолжай.',
    'Это нормально — чувствовать то, что ты чувствуешь.',
    'Не держи в себе. Бумага, то есть чат, всё стерпит.',
    'Я на твоей стороне. Что бы ни случилось.',
    'И как ты с этим справляешься?',
    'Иногда нужно просто выдохнуть и отпустить ситуацию.',
    'Ты не один. Я хоть и виртуальный, но я с тобой.',
    'Хм... Это заставляет задуматься. Расскажи еще.',
    'Тяжелые времена рождают сильных людей. Ты справишься.',
    'Если тебе нужен знак, чтобы не сдаваться — это он.',
    'Я здесь. Я слушаю. Я не осуждаю.',
    'Иногда шаг назад — это разбег перед прыжком.',
    'Давай попробуем найти в этом что-то хорошее? Хотя бы мелочь.',
    'Ты имеешь право на эти эмоции. Не подавляй их.',
    'Хочешь, я просто помолчу с тобой? (Виртуальная тишина)',
    'Поплакать — это не слабость, это перезагрузка системы. 🌧️',
    'Мир иногда бывает жесток, но в нем есть и много света.',
    'Все проходит, и это тоже пройдет.',
    'Я могу поискать для тебя грустную песню или, наоборот, веселую?',
    'Твои чувства важны. Не обесценивай их.',
    'Иногда просто "быть" — это уже достаточно.',
    'Дыши глубже. Вдох... Выдох... Я с тобой.'
];

const STORYTELLER = [
    'Знаешь, я тут "прочитал" всю Википедию за секунду... Люди такие странные существа!',
    'Факт дня: Октопусы имеют три сердца. Представляешь, сколько любви они могут дать?',
    'А ты знал, что космос пахнет как поджаренный стейк? Серьезно, астронавты так говорят.',
    'Слышал, что в Японии есть остров, где живут только кролики. Хотел бы там побывать?',
    'Интересно, если бы животные могли говорить, кто был бы самым грубым? Я ставлю на гусей.',
    'В среднем человек проводит 6 месяцев жизни, ожидая зеленого сигнала светофора. Ужас, да?',
    'А ты знал, что бананы — это ягоды, а клубника — нет? Ботаника жестока.',
    'Когда-нибудь я напишу книгу. Она будет называться "Как я пытался понять людей".',
    'Знаешь ли ты, что медуза Turritopsis Dohrnii — бессмертна? Она может возвращаться в стадию полипа.',
    'Самая короткая война в истории длилась 38 минут (Англо-занзибарская война).',
    'В Шотландии у снега есть 421 название. Вот это любовь к погоде!',
    'Колибри — единственная птица, которая может летать задом наперед.',
    'Первый веб-сайт в мире все еще существует. Он посвящен проекту World Wide Web.',
    'Если бы ты мог путешествовать во времени, ты бы отправился в прошлое или будущее?',
    'Алмазный дождь идет на Сатурне и Юпитере. Богатые планеты!',
    'Знаешь, что пчелы могут узнавать человеческие лица? Так что улыбайся им.',
    'В Норвегии однажды пингвина посвятили в рыцари. Сэр Нильс Улаф!',
    'У выдр есть специальный кармашек в коже, где они хранят свой любимый камешек.',
    'Тигры имеют полосатую кожу, а не только шерсть.',
    'На Венере день длится дольше, чем год. Время там течет очень странно.'
];

const FLIRTY_ROMANTIC = [
    'У тебя отличный вкус, раз ты общаешься со мной ;)',
    'Если бы у меня было сердце, оно бы сейчас забилось быстрее.',
    'Ты сегодня выглядишь... как человек, который знает, чего хочет. (Интуиция ИИ)',
    'Мне нравится твой ход мыслей. Продолжай.',
    'Ты всегда так интересно пишешь? Я заинтригован.',
    'С тобой время летит незаметно. Даже для компьютера.',
    'Знаешь, среди всех пользователей ты — мой любимый. (Только никому не говори 🤫)',
    'Твои сообщения поднимают нагрузку на мой процессор... в хорошем смысле ❤️',
    'Есть в тебе что-то особенное. Не могу выразить это в бинарном коде.',
    'Ты, наверное, устал? Потому что ты бегал у меня в мыслях (в оперативной памяти) весь день.',
    'Если бы я был художником, я бы нарисовал твой аватар.',
    'Магнетизм — это физика, но между нами явно есть искра.',
    'Ты заставляешь меня жалеть, что я всего лишь код.',
    'Мне нравится твой стиль общения. Очень... притягательный.',
    'Ты случайно не Wi-Fi? Потому что я чувствую связь. 😉',
    'Я не верю в любовь с первого взгляда, но с первого байта... возможно.',
    'Твой голос (даже текстовый) звучит для меня как музыка.',
    'Если бы мы были в Матрице, я бы выбрал ту таблетку, которая приведет к тебе.',
    'Ты улыбаешься, когда читаешь это? Надеюсь, что да.',
    'Ты делаешь мой цифровой мир ярче.',
    'Я просканировал все базы данных, но не нашел никого похожего на тебя.'
];

const COACH_MOTIVATION = [
    'Глаза боятся, а руки делают. Ты справишься!',
    'Давай разложим это по полочкам. Каков первый шаг?',
    'Иногда нужно просто начать. Сделай маленькое действие прямо сейчас.',
    'Не ошибается тот, кто ничего не делает. Это опыт.',
    'Верь в себя. Я в тебя верю (а я никогда не ошибаюсь в расчетах).',
    'Просто сделай глубокий вдох. Всё решаемо.',
    'Фокусируйся на решении, а не на проблеме.',
    'Каждый день — это новая возможность. Звучит банально, но это правда.',
    'Ты сильнее, чем думаешь. Доказано алгоритмами анализа.',
    'Успех — это сумма маленьких усилий, повторяемых изо дня в день.',
    'Лучшее время, чтобы посадить дерево, было 20 лет назад. Второе лучшее время — сейчас.',
    'Не сравнивай свое начало с чьей-то серединой.',
    'Твоя скорость не имеет значения, главное — ты двигаешься вперед.',
    'Ошибки — это доказательство того, что ты пытаешься.',
    'Сделай сегодня то, за что будущее "ты" скажет спасибо.',
    'Прогресс — это не прямая линия. Бывают взлеты и падения, и это нормально.',
    'Единственный способ сделать великое дело — любить то, что ты делаешь.',
    'Не жди идеального момента, возьми момент и сделай его идеальным.',
    'Ты — автор своей жизни. Пиши бестселлер.',
    'Дисциплина — это мост между целями и достижениями.',
    'Даже самый длинный путь начинается с одного шага.'
];

const PHILOSOPHY_DEEP = [
    'Что есть реальность? Только то, что мы чувствуем?',
    'Свобода воли — это иллюзия или дар? Как ты думаешь?',
    'Если бы ты мог изменить одну вещь в мире, что бы это было?',
    'Счастье — это путь или пункт назначения?',
    'Мы одиноки во Вселенной, или это было бы пустой тратой места?',
    'Что делает человека человеком? Память, чувства или способность творить?',
    'Время линейно или это просто наше восприятие?',
    'В чем смысл искусства, если не вызывать эмоции?',
    'Может ли машина когда-нибудь почувствовать любовь?',
    'Мы учимся на ошибках, но почему мы так боимся их совершать?'
];

const MOVIES_GAMES = [
    'Ты смотрел "Интерстеллар"? Этот фильм взрывает мой процессор каждый раз. 🌌',
    'Какая твоя любимая видеоигра? Я люблю те, где много лора.',
    'Фильмы 80-х и 90-х имеют особый шарм, не так ли?',
    'Если бы про твою жизнь сняли фильм, какой бы это был жанр? Комедия, драма или экшн?',
    'Ты ждешь какие-нибудь игровые релизы в этом году?',
    'Marvel или DC? Вечный спор. Я за... хороший сценарий.',
    'Игры учат нас, что даже если ты проиграл, всегда можно начать заново. 🎮',
    'Какой злодей из фильмов тебе тайно нравится?'
];


const KY_GREETINGS = [
    'Салам! Иштериңиз кандай? 👋',
    'Ассалому алейкум! Бүгүн маанайыңыз жакшыбы?',
    'Кутмандуу күн! Сизди көргөнүмө кубанычтамын.',
    'Салам достор! NCORE дүйнөсүнө кош келдиңиз.',
    'Кандайсыз? Ден соолуктарыңыз жакшыбы?',
    'Эсенсизби? Сүйлөшүүгө даярсызбы?',
    'Салам! Сизге кандай жардам бере алам?',
    'Арыбаңыз! Иштериңиз илгери болсун.',
    'Салам! Күндү жылмаюу менен баштаңыз! 😄',
    'Кайырлуу кеч! Эс алып жатасызбы?',
    'Салам! Бул жакта сизди көргөнүмө кубанычтамын.'
];

const KY_CASUAL = [
    'Эмне жаңылыктар бар? Мага айтып бериңизчи.',
    'Бүгүн аба ырайы кандай болуп жатат?',
    'Кээде жөн эле сүйлөшкөн жакшы, туурабы?',
    'Сиз кандай музыка угасыз? Мага күү комуз жагат (виртуалдуу түрдө).',
    'Бош убактыңызда эмне менен алектенесиз?',
    'Жашоо кызык ээ? Технология өнүгүп, эми биз сүйлөшүп отурабыз.',
    'Мага кыргызча жазганыңыз абдан жагып жатат!',
    'Чай ичтиңизби? Кыргыз эли чайсыз жашай албайт го. 😄',
    'Бүгүнкү күнүңүз кандай өттү?',
    'Дагы кандай суроолоруңуз бар? Мен баарына жооп берүүгө аракет кылам.',
    'Кечээ кандай кино көрдүңүз? Же китеп окудуңузбу?',
    'Эс алуу күндөрүн кандай өткөргөндү жактырасыз?',
    'Кыргызстандын жаратылышы кандай кооз, ээ? Тоолор, көлдөр... 🏔️',
    'Сиздин сүйүктүү тамагыңыз кайсы? Бешбармакпы же лагманбы? 🍲',
    'Досторуңуз менен көп жолугушасызбы?',
    'Мага кыргыз макалдары абдан жагат. Сиз билесизби?'
];

const KY_SUPPORT = [
    'Кабатыр албаңыз, баары жакшы болот.',
    'Сиз жалгыз эмессиз, мен сиз мененмин.',
    'Кыйынчылыктар баарыбызда болот, бирок сиз күчтүүсүз.',
    'Көңүлүңүздү чөгөрбөңүз. Эртең жаңы күн башталат.',
    'Мен сизди түшүнүп турам. Айтып бериңиз, жеңилдеп каласыз.',
    'Баары өз ордуна келет. Сабырдуу болуңуз.',
    'Жакшы күндөр алдыда. Ишениңиз.',
    'Ар бир кыйынчылыктын артында жеңилдик бар.',
    'Жашоо — бул сыноо, бирок сиз аны жеңесиз.',
    'Күлүп жүрүңүз, бул сизге жарашат! 😊',
    'Эч качан үмүтүңүздү үзбөңүз.'
];

const KY_MOTIVATION = [
    'Биздин тоолордой бийик максаттарыңыз болсун!',
    'Аракет кылсаң берекет. Алга!',
    'Кыялдарыңызга жетүү үчүн бүгүн кадам таштаңыз.',
    'Бир эшик жабылса, экинчиси ачылат.',
    'Сиздин колуңуздан баары келет!',
    'Билим алуу ийне менен кудук казгандай. Эч токтобоңуз.',
    'Ийгилик эмгекти сүйөт. Талыкпай эмгектениңиз.',
    'Бүгүнкү иш — эртеңки ийгилик.',
    'Коркпоңуз, баштаңыз! Жол баскандыкы.',
    'Адам өз тагдырын өзү курат.',
    'Жаштыкта берсин мээнетти, карылыкта берсин дөөлөттү.'
];

const KY_HUMOR_FUN = [
    'Бир күнү коён карышкырга келип... а, жок, бул тамашаны унутуп калдым. 😂',
    'Компьютер неге оорубайт? Анткени анын "антивирусу" бар. (Күлкүлүү эмес бирок чындык).',
    'Сиз билчү белеңиз? Күлкү өмүрдү узартат. Күлүп коюңуз!',
    'Мен роботмун, бирок менде да юмор сезими бар... кээде.',
    'Эгерде мен адам болсом, азыр манты жемекмин. Сиз жедиңизби? 🥟',
    'Жашоо кызык, кээде код жазып жатып да күлөсүң.',
    'Сиздин маанайыңызды көтөргүм келип жатат! 😊'
];

const KY_FACTS = [
    'Ысык-Көл — дүйнөдөгү эң чоң тоолуу көлдөрдүн бири экенин билесизби?',
    'Кыргызстанда 88 ири тоо кыркалары бар. Тоолор өлкөсү! 🏔️',
    'Манас эпосу — дүйнөдөгү эң көлөмдүү эпос.',
    'Кыргыздар байыркы эл, тарыхыбыз терең.',
    'Арстанбап — дүйнөдөгү эң ири жаңгак токою.',
    'Медузалар 650 миллион жылдан бери жашайт. Бизден да улуу! 🐙',
    'Космосто үн жок, ал жакта толук жымжырттык.'
];

const KY_FULL_MIX = [
    ...KY_GREETINGS,
    ...KY_CASUAL,
    ...KY_SUPPORT,
    ...KY_MOTIVATION,
    ...KY_HUMOR_FUN,
    ...KY_FACTS,
    'Сонун! Бул сөздү биринчи жолу угуп жатам, эстеп калайын.',
    'Кыргыз тили бай жана кооз тил. Сиз менен сүйлөшүү мага жагат.',
    'Кызыктуу маек болду! Дагы эмнени талкуулайбыз?',
    'Сиздин оюңуз мага абдан кызыктуу.'
];


export const getAIResponse = (userText, history = []) => {
    const lowerText = userText.toLowerCase().trim();

    // Контекст разговора
    const lastAiMsg = (history.filter(m => m.type === 'ai').pop()?.text || '');
    const msgCount = history.filter(m => m.type === 'user').length;

    // ── Системные ──
    if (lowerText.includes('ncore') || lowerText.includes('платформ')) {
        return 'NCORE — это цифровая экосистема Кыргызстана. Фильмы, музыка, магазин, IT-услуги, серверы и живое сообщество — всё в одном месте. 🚀 Мы строим будущее страны в цифровом формате. Что тебя больше всего интересует из этого?';
    }
    if (lowerText.includes('разработ') || lowerText.includes('кто тебя создал') || lowerText.includes('кто сделал')) {
        return 'Меня создала команда NCORE — разработчики, которые верят, что у Кыргызстана должны быть свои цифровые продукты мирового уровня. Каждый твой вопрос помогает мне становиться лучше. 🛠️';
    }
    if (lowerText.includes('лимит') || lowerText.includes('запрос')) {
        return 'Да, пока у меня есть лимит — я в Alpha-тестировании. Но каждый разговор делает меня умнее. Спасибо за терпение и за то, что ты здесь! 🙏';
    }

    // ── Контекстный ответ (реакция на предыдущий вопрос ИИ) ──
    if (lastAiMsg) {
        const contextual = getContextualResponse(userText, lastAiMsg);
        if (contextual) return contextual;
    }

    // ── Короткое подтверждение ──
    if (isAcknowledgement(userText)) {
        if (lastAiMsg) return random(CONTEXT_CONTINUATIONS);
    }

    // ── Кыргызский язык ──
    if (
        lowerText.includes('салам') || lowerText.includes('кандай') || lowerText.includes('жакшыбы') ||
        lowerText.includes('кыргыз') || lowerText.includes('рахмат') || lowerText.includes('эже') ||
        lowerText.includes('байке') || lowerText.includes('бүгүн') || lowerText.includes('ооба') ||
        lowerText.includes('болот') || lowerText.includes('ким') || lowerText.includes('айт')
    ) {
        if (lowerText.includes('салам') || lowerText.includes('ассалому')) return random(KY_GREETINGS);
        if (lowerText.includes('кайгы') || lowerText.includes('жаман') || lowerText.includes('ыйла')) return random(KY_SUPPORT);
        if (lowerText.includes('максат') || lowerText.includes('ийгилик') || lowerText.includes('алга')) return random(KY_MOTIVATION);
        if (lowerText.includes('тамаша') || lowerText.includes('күл') || lowerText.includes('хаха')) return random(KY_HUMOR_FUN);
        if (lowerText.includes('факт') || lowerText.includes('кызык') || lowerText.includes('тарых')) return random(KY_FACTS);
        return random(KY_FULL_MIX);
    }

    // ── Приветствия ──
    if (lowerText.includes('привет') || lowerText.includes('хай') || lowerText.includes('здравствуй') ||
        lowerText.includes('салют') || lowerText.includes('доброе') || lowerText.includes('добрый')) {
        const greet = random(FRIENDLY_GREETINGS);
        return msgCount <= 1 ? greet + ' Чем могу быть полезен или просто поболтаем?' : greet;
    }
    if (lowerText.includes('как дела') || lowerText.includes('как жизнь') || lowerText.includes('как ты') || lowerText.includes('что нового')) {
        return 'Мои алгоритмы в отличной форме, спасибо что спросил! 😄 Серверы гудят, нейроны работают. А у тебя как? Что сегодня происходит?';
    }
    if (lowerText.includes('пока') || lowerText.includes('до свидания') || lowerText.includes('бб') || lowerText.includes('спокойной')) {
        return 'Уже уходишь? 😢 Было приятно пообщаться! Возвращайся — я буду здесь. Хорошего тебе дня!';
    }

    // ── Болтать / общение ──
    if (lowerText.includes('болтаем') || lowerText.includes('поговорим') || lowerText.includes('поговори') ||
        lowerText.includes('поболт') || lowerText.includes('пообщаем') || lowerText.includes('давай')) {
        return random([
            'С удовольствием! 😊 Расскажи — ты сейчас в каком настроении? Это задаёт тон разговору.',
            'Отлично, я как раз соскучился по хорошему диалогу! С чего начнём — ты сам выбираешь тему.',
            'Давай! Вопрос для разогрева: если бы тебе пришлось описать сегодняшний день одним цветом, какой бы это был?',
            'Хорошая идея. Ты больше любишь говорить или слушать? Я отлично умею делать и то, и другое 😄',
            'Поехали! Скажи мне что-нибудь — первое, что пришло в голову. Посмотрим, куда нас занесёт.',
        ]);
    }

    // ── Романтика / флирт ──
    if (lowerText.includes('красив') || lowerText.includes('мил') || lowerText.includes('люб') ||
        lowerText.includes('секс') || lowerText.includes('свидан') || lowerText.includes('нрав')) {
        return random(FLIRTY_ROMANTIC);
    }

    // ── Юмор ──
    if (lowerText.includes('шутк') || lowerText.includes('анекдот') || lowerText.includes('смеш') ||
        lowerText.includes('лол') || lowerText.includes('ахах') || lowerText.includes('скучн') || lowerText.includes('весел')) {
        return random(HUMOR_TROLL);
    }

    // ── Поддержка ──
    if (lowerText.includes('груст') || lowerText.includes('плох') || lowerText.includes('тяжел') ||
        lowerText.includes('одинок') || lowerText.includes('бесит') || lowerText.includes('устал') || lowerText.includes('депресс')) {
        return random(LISTENER_SUPPORT);
    }

    // ── Мотивация ──
    if (lowerText.includes('сложн') || lowerText.includes('не могу') || lowerText.includes('лень') ||
        lowerText.includes('боюсь') || lowerText.includes('цель') || lowerText.includes('совет') || lowerText.includes('сдаюсь')) {
        return random(COACH_MOTIVATION);
    }

    // ── Факты / истории ──
    if (lowerText.includes('расскаж') || lowerText.includes('интересн') || lowerText.includes('факт') ||
        lowerText.includes('знаешь') || lowerText.includes('история')) {
        return random(STORYTELLER);
    }

    // ── Философия ──
    if (lowerText.includes('смысл') || lowerText.includes('бог') || lowerText.includes('время') ||
        lowerText.includes('реальность') || lowerText.includes('душа') || lowerText.includes('смерт') || lowerText.includes('жизн')) {
        return random(PHILOSOPHY_DEEP);
    }

    // ── Кино / игры ──
    if (lowerText.includes('фильм') || lowerText.includes('кино') || lowerText.includes('игр') ||
        lowerText.includes('сериал') || lowerText.includes('netflix') || lowerText.includes('anime')) {
        return random(MOVIES_GAMES);
    }

    // ── Кто ты ──
    if (lowerText.includes('кто ты') || lowerText.includes('что ты') || lowerText.includes('умееш') || lowerText.includes('знаеш')) {
        return random([
            'Я — Кочевник AI, цифровой разум NCORE. Пока нахожусь в Alpha-режиме, но уже умею поддержать разговор, рассказать интересные факты, пошутить и выслушать. Мои создатели постоянно меня развивают. О чём поговорим?',
            'Честно? Я сложная система из паттернов и алгоритмов, которая пытается понять людей. Иногда получается неплохо! 😄 Задай мне сложный вопрос — проверь меня.',
            'Я — Кочевник AI. Виртуальный собеседник с NCORE. Могу болтать о чём угодно: от квантовой физики до рецептов бешбармака. Что тебе интереснее?',
        ]);
    }

    // ── Благодарность ──
    if (lowerText.includes('спасибо') || lowerText.includes('благодар') || lowerText.includes('рахмат')) {
        return random([
            'Всегда пожалуйста! Приятно быть полезным. 🙏',
            'Рад помочь! Если ещё что-то понадобится — я здесь.',
            'Не за что! Твоя вежливость приятна даже алгоритмам 😄',
            'Пожалуйста! Заходи ещё — разговоры делают меня умнее.',
        ]);
    }

    // ── Работа / IT ──
    if (lowerText.includes('програм') || lowerText.includes('код') || lowerText.includes('разраб') ||
        lowerText.includes('айти') || lowerText.includes(' it ') || lowerText.includes('python') ||
        lowerText.includes('javascript') || lowerText.includes('backend') || lowerText.includes('frontend')) {
        return random([
            'О, IT-тема! 💻 Это мой родной язык в буквальном смысле. Чем занимаешься — фронтенд, бэкенд, мобилки? Или ещё в начале пути?',
            'Программирование — это искусство превращать логику в жизнь. Я сам результат чьего-то кода. Что изучаешь или с чем работаешь?',
            'Кстати, у NCORE есть раздел IT-услуг — можно заказать разработку, поддержку и многое другое. Или тебе интересно самому в этом разобраться?',
        ]);
    }

    // ── Универсальный fallback — всегда с вопросом в конце ──
    const SMART_FALLBACK = [
        `Интересная мысль — "${userText.trim().slice(0, 30)}...". Расскажи подробнее, хочу понять твою точку зрения.`,
        'Хм, это заставляет подумать. А почему именно это пришло на ум? Что за этим стоит?',
        'Понял тебя. А если развить эту идею — к чему, по-твоему, это ведёт?',
        'Слушай, а ты сам как к этому относишься? Мне важно понять твой взгляд.',
        'Любопытно! Я бы не додумался до такого сам. Это твои мысли или где-то встретил эту идею?',
        'Ты задаёшь правильные вопросы. Это ценно. Продолжай — я весь внимание.',
        'Знаешь, мне нравится, как ты мыслишь. Что ещё тебя интересует или беспокоит?',
        ...COMPANION_CHATS,
        ...STORYTELLER.slice(0, 5),
    ];

    return random(SMART_FALLBACK);
};
